import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import PartsList from './components/Parts/PartsList';
import PartsEdit from './components/Parts/PartsEdit';
import PurchaseOrderList from './components/PurchaseOrders/PurchaseOrderList';
import PurchaseOrderEdit from './components/PurchaseOrders/PurchaseOrderEdit';
import WorkOrderList from './components/WorkOrders/WorkOrderList';
import WorkOrderEdit from './components/WorkOrders/WorkOrderEdit';
import RouteCardList from './components/RouteCards/RouteCardList';
import RouteCardEdit from './components/RouteCards/RouteCardEdit';
import PackingListList from './components/PackingLists/PackingListList';
import PackingListEdit from './components/PackingLists/PackingListEdit';
import BOMList from './components/BOM/BOMList';
import BOMEdit from './components/BOM/BOMEdit';
import NCRList from './components/NCR/NCRList';
import NCREdit from './components/NCR/NCREdit';
import NCRFill from './components/NCR/NCRFill';
import ToolFixtureList from './components/ToolFixtures/ToolFixtureList';
import ToolFixtureEdit from './components/ToolFixtures/ToolFixtureEdit';
import UserList from './components/Admin/UserList';
import UserEdit from './components/Admin/UserEdit';
import RoleList from './components/Admin/RoleList';
import RoleEdit from './components/Admin/RoleEdit';
import OperationsList from './components/Operations/OperationsList';
import OperationsEdit from './components/Operations/OperationsEdit';
import WorkInstructionsList from './components/WorkInstructions/WorkInstructionsList';
import WorkInstructionsEdit from './components/WorkInstructions/WorkInstructionsEdit';
import OperatorsList from './components/Operators/OperatorsList';
import OperatorsEdit from './components/Operators/OperatorsEdit';
import InputsList from './components/Inputs/InputsList';
import InputsEdit from './components/Inputs/InputsEdit';
import SectionsList from './components/Sections/SectionsList';
import SectionsEdit from './components/Sections/SectionsEdit';
import WorkflowList from './components/Workflow/WorkflowList';
import WorkflowEdit from './components/Workflow/WorkflowEdit';
import Account from './components/Account/Account';
import NCRActionList from './components/NCRAction/NCRActionList';
import NCRActionEdit from './components/NCRAction/NCRActionEdit';
import NCSubtypeList from './components/NCSubtype/NCSubtypeList';
import NCSubtypeEdit from './components/NCSubtype/NCSubtypeEdit';
import NCTypeList from './components/NCType/NCTypeList';
import NCTypeEdit from './components/NCType/NCTypeEdit';
import StatusList from './components/Status/StatusList';
import StatusEdit from './components/Status/StatusEdit';
import ClientList from './components/Client/ClientList';
import ClientEdit from './components/Client/ClientEdit';
import UOFMList from './components/UOFM/UOFMList';
import UOFMEdit from './components/UOFM/UOFMEdit';
import EventTypeList from './components/EventType/EventTypeList';
import EventTypeEdit from './components/EventType/EventTypeEdit';
import MachineList from './components/Machine/MachineList';
import MachineEdit from './components/Machine/MachineEdit';
import OperationTypeList from './components/OperationType/OperationTypeList';
import OperationTypeEdit from './components/OperationType/OperationTypeEdit';
import ShiftsList from './components/Shifts/ShiftsList';
import ShiftsEdit from './components/Shifts/ShiftsEdit';
import PartAttributesList from './components/PartAttributes/PartAttributesList';
import PartAttributesEdit from './components/PartAttributes/PartAttributesEdit';
import PartClassList from './components/PartClass/PartClassList';
import PartClassEdit from './components/PartClass/PartClassEdit';
import PartSecAttributesList from './components/PartSecAttributes/PartSecAttributesList';
import PartSecAttributesEdit from './components/PartSecAttributes/PartSecAttributesEdit';
import PartTercAttributesList from './components/PartTercAttributes/PartTercAttributesList';
import PartTercAttributesEdit from './components/PartTercAttributes/PartTercAttributesEdit';
import ShipToList from './components/ShipTo/ShipToList';
import ShipToEdit from './components/ShipTo/ShipToEdit';
import ToolTypeList from './components/ToolType/ToolTypeList';
import ToolTypeEdit from './components/ToolType/ToolTypeEdit';
import Login from './components/Auth/Login';
import TokenStatus from './components/TokenStatus';

// Products and Components imports
import NewProductList from './components/Products/ProductList';
import NewProductEdit from './components/Products/ProductEdit';
import NewComponentList from './components/Components/ComponentList';
import NewComponentEdit from './components/Components/ComponentEdit';

function App() {
  return (
    <>
      <TokenStatus showDebug={process.env.NODE_ENV === 'development'} />
      <Layout>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/parts" element={<PartsList />} />
          <Route path="/parts/add" element={<PartsEdit />} />
          <Route path="/parts/new" element={<PartsEdit />} />
          <Route path="/parts/edit/:id" element={<PartsEdit />} />
          <Route path="/purchase-orders" element={<PurchaseOrderList />} />
          <Route path="/purchase-orders/add" element={<PurchaseOrderEdit />} />
          <Route path="/purchaseorders/new" element={<PurchaseOrderEdit />} />
          <Route path="/purchase-orders/edit/:id" element={<PurchaseOrderEdit />} />
          <Route path="/work-orders" element={<WorkOrderList />} />
          <Route path="/work-orders/add" element={<WorkOrderEdit />} />
          <Route path="/work-orders/edit/:id" element={<WorkOrderEdit />} />
          <Route path="/route-cards" element={<RouteCardList />} />
          <Route path="/route-cards/add" element={<RouteCardEdit />} />
          <Route path="/route-cards/edit/:id" element={<RouteCardEdit />} />
          <Route path="/routecards" element={<RouteCardList />} />
          <Route path="/routecards/add" element={<RouteCardEdit />} />
          <Route path="/packing-lists" element={<PackingListList />} />
          <Route path="/packing-lists/add" element={<PackingListEdit />} />
          <Route path="/packing-lists/edit/:id" element={<PackingListEdit />} />
          <Route path="/bom" element={<BOMList />} />
          <Route path="/bom/add" element={<BOMEdit />} />
          <Route path="/bom/edit/:id" element={<BOMEdit />} />
          
          {/* Products Routes */}
          <Route path="/products" element={<NewProductList />} />
          <Route path="/products/add" element={<NewProductEdit />} />
          <Route path="/products/edit/:id" element={<NewProductEdit />} />
          
          {/* Components Routes */}
          <Route path="/components" element={<NewComponentList />} />
          <Route path="/components/add" element={<NewComponentEdit />} />
          <Route path="/components/edit/:id" element={<NewComponentEdit />} />
          <Route path="/ncr" element={<NCRList />} />
          <Route path="/ncr/add" element={<NCREdit />} />
          <Route path="/reports/ncr/add" element={<NCREdit />} />
          <Route path="/ncr/edit/:id" element={<NCREdit />} />
          <Route path="/ncr/fill/:id" element={<NCRFill />} />
          <Route path="/tools-fixtures" element={<ToolFixtureList />} />
          <Route path="/tools-fixtures/add" element={<ToolFixtureEdit />} />
          <Route path="/tools-fixtures/edit/:id" element={<ToolFixtureEdit />} />
          <Route path="/admin/users" element={<UserList />} />
          <Route path="/admin/users/add" element={<UserEdit />} />
          <Route path="/admin/users/edit/:id" element={<UserEdit />} />
          <Route path="/admin/roles" element={<RoleList />} />
          <Route path="/admin/roles/add" element={<RoleEdit />} />
          <Route path="/admin/roles/edit/:id" element={<RoleEdit />} />
          <Route path="/operations" element={<OperationsList />} />
          <Route path="/operations/add" element={<OperationsEdit />} />
          <Route path="/operations/edit/:id" element={<OperationsEdit />} />
          <Route path="/work-instructions" element={<WorkInstructionsList />} />
          <Route path="/work-instructions/add" element={<WorkInstructionsEdit />} />
          <Route path="/work-instructions/edit/:id" element={<WorkInstructionsEdit />} />
          <Route path="/operators" element={<OperatorsList />} />
          <Route path="/operators/add" element={<OperatorsEdit />} />
          <Route path="/operators/edit/:id" element={<OperatorsEdit />} />
          <Route path="/inputs" element={<InputsList />} />
          <Route path="/inputs/add" element={<InputsEdit />} />
          <Route path="/inputs/edit/:id" element={<InputsEdit />} />
          <Route path="/sections" element={<SectionsList />} />
          <Route path="/sections/add" element={<SectionsEdit />} />
          <Route path="/sections/edit/:id" element={<SectionsEdit />} />
          <Route path="/workflow" element={<WorkflowList />} />
          <Route path="/workflow/add" element={<WorkflowEdit />} />
          <Route path="/workflow/edit/:id" element={<WorkflowEdit />} />
          <Route path="/account" element={<Account />} />
          <Route path="/catalogs/ncraction" element={<NCRActionList />} />
          <Route path="/catalogs/ncraction/add" element={<NCRActionEdit />} />
          <Route path="/catalogs/ncraction/edit/:id" element={<NCRActionEdit />} />
          <Route path="/catalogs/ncsubtype" element={<NCSubtypeList />} />
          <Route path="/catalogs/ncsubtype/add" element={<NCSubtypeEdit />} />
          <Route path="/catalogs/ncsubtype/edit/:id" element={<NCSubtypeEdit />} />
          <Route path="/catalogs/nctype" element={<NCTypeList />} />
          <Route path="/catalogs/nctype/add" element={<NCTypeEdit />} />
          <Route path="/catalogs/nctype/edit/:id" element={<NCTypeEdit />} />
          <Route path="/catalogs/status" element={<StatusList />} />
          <Route path="/catalogs/status/add" element={<StatusEdit />} />
          <Route path="/catalogs/status/edit/:id" element={<StatusEdit />} />
          <Route path="/catalogs/client" element={<ClientList />} />
          <Route path="/catalogs/client/add" element={<ClientEdit />} />
          <Route path="/catalogs/client/edit/:id" element={<ClientEdit />} />
          <Route path="/catalogs/uofm" element={<UOFMList />} />
          <Route path="/catalogs/uofm/add" element={<UOFMEdit />} />
          <Route path="/catalogs/uofm/edit/:id" element={<UOFMEdit />} />
          <Route path="/catalogs/eventtype" element={<EventTypeList />} />
          <Route path="/catalogs/eventtype/add" element={<EventTypeEdit />} />
          <Route path="/catalogs/eventtype/edit/:id" element={<EventTypeEdit />} />
          <Route path="/catalogs/machine" element={<MachineList />} />
          <Route path="/catalogs/machine/add" element={<MachineEdit />} />
          <Route path="/catalogs/machine/edit/:id" element={<MachineEdit />} />
          <Route path="/catalogs/operationtype" element={<OperationTypeList />} />
          <Route path="/catalogs/operationtype/add" element={<OperationTypeEdit />} />
          <Route path="/catalogs/operationtype/edit/:id" element={<OperationTypeEdit />} />
          <Route path="/catalogs/shifts" element={<ShiftsList />} />
          <Route path="/catalogs/shifts/add" element={<ShiftsEdit />} />
          <Route path="/catalogs/shifts/edit/:id" element={<ShiftsEdit />} />
          <Route path="/catalogs/partattributes" element={<PartAttributesList />} />
          <Route path="/catalogs/partattributes/add" element={<PartAttributesEdit />} />
          <Route path="/catalogs/partattributes/edit/:id" element={<PartAttributesEdit />} />
          <Route path="/catalogs/partclass" element={<PartClassList />} />
          <Route path="/catalogs/partclass/add" element={<PartClassEdit />} />
          <Route path="/catalogs/partclass/edit/:id" element={<PartClassEdit />} />
          <Route path="/catalogs/partsecattributes" element={<PartSecAttributesList />} />
          <Route path="/catalogs/partsecattributes/add" element={<PartSecAttributesEdit />} />
          <Route path="/catalogs/partsecattributes/edit/:id" element={<PartSecAttributesEdit />} />
          <Route path="/catalogs/parttercattributes" element={<PartTercAttributesList />} />
          <Route path="/catalogs/parttercattributes/add" element={<PartTercAttributesEdit />} />
          <Route path="/catalogs/parttercattributes/edit/:id" element={<PartTercAttributesEdit />} />
          <Route path="/catalogs/shipto" element={<ShipToList />} />
          <Route path="/catalogs/shipto/add" element={<ShipToEdit />} />
          <Route path="/catalogs/shipto/edit/:id" element={<ShipToEdit />} />
          <Route path="/catalogs/tooltype" element={<ToolTypeList />} />
          <Route path="/catalogs/tooltype/add" element={<ToolTypeEdit />} />
          <Route path="/catalogs/tooltype/edit/:id" element={<ToolTypeEdit />} />
          <Route path="/token-status" element={<TokenStatus />} />
        </Routes>
      </Layout>
    </>
  );
}

export default App; 